import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CallbackType } from '@callback/const';
import { CallbackService } from '@callback/data-access';
import {
  PersonalDataAgreeTextCallbackComponent,
  PhoneAuthorizedUserDirective,
  PhoneMaskFixDirective,
} from '@sdvor/shared/ui';
import { SdvorButtonComponent, SdvorInputComponent } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { ErrorMsgComponent, SuccessMsgComponent } from '../form-state-messages';

@Component({
  selector: 'sd-callback-form',
  templateUrl: './callback-form.component.html',
  styleUrls: ['./callback-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SdvorInputComponent,
    ReactiveFormsModule,
    SdvorButtonComponent,
    AsyncPipe,
    PersonalDataAgreeTextCallbackComponent,
    SuccessMsgComponent,
    ErrorMsgComponent,
    PhoneMaskFixDirective,
    PhoneAuthorizedUserDirective,
  ],
})
export class CallbackFormComponent implements OnInit {
  callbackForm: FormGroup;
  @Input() callBackType: CallbackType;
  isMobile$: Observable<boolean>;
  formState$: Observable<StateUtils.LoaderState<unknown>>;

  constructor(
    private fb: FormBuilder,
    private callbackService: CallbackService,
    public deviceService: DeviceService,
  ) {}

  ngOnInit(): void {
    this.isMobile$ = this.deviceService.isMobileSmDown$;

    this.callbackForm = this.fb.group({
      phone: this.fb.control(null, { validators: [Validators.required, Validators.minLength(10)] }),
    });

    this.formState$ = this.callbackService.getProcess();
  }

  submitForm(): void {
    if (this.callbackForm.valid) {
      this.callbackService.requestCallback({
        type: this.callBackType,
        phone: this.callbackForm.value.phone,
      });
    }
  }
}
